// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1y-0 {\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n  max-width: 200px;\n}\n\n._1y-1 {\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n}\n\n._1y-2 {\n  display: inline-flex;\n}\n\n._1y-3 {\n  color: var(--redo-colors-text-text-tertiary-600);\n}\n\n._1y-4 {\n  outline: 1px solid var(--redo-colors-border-border-secondary);\n}\n", ""]);
// Exports
export var dropdownButton = "_1y-0";
export var fullWidthDropdownButton = "_1y-1";
export var iconPlaceholder = "_1y-2";
export var icon = "_1y-3";
export var shortcutContainer = "_1y-4";
export default ___CSS_LOADER_EXPORT___;
